import { motion } from "framer-motion";

export default function ProblemSection() {
  return (
    <section data-testid="problem-section" className="py-24 md:py-32 relative">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2
            data-testid="problem-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-8"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            You're losing leads and you don't even know it.
          </h2>

          <div className="space-y-5 text-zinc-400 text-base md:text-lg leading-relaxed">
            <p>
              Every day, leads come in while you're busy. They don't get a reply fast enough. They move on.
            </p>
            <p>
              The average business loses <span className="text-white font-semibold">40 to 60 percent</span> of its leads just from slow follow up. Not because the lead wasn't interested. Because nobody responded in time.
            </p>
            <p>
              That's not a leads problem. That's a systems problem.
            </p>
            <p>
              And most "AI tools" don't fix it — they just send the same robotic messages to everyone and make it worse.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
